import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Εισαγωγή του hook για πλοήγηση
import {
  Container, Box, Paper, Typography, TextField,
  Button, Link, InputAdornment, IconButton, Alert
} from '@mui/material';
import { Visibility, VisibilityOff, LockOutlined } from '@mui/icons-material';

export default function LoginPage() {
  const navigate = useNavigate(); // Αρχικοποίηση πλοήγησης
  const [showPassword, setShowPassword] = useState(false);

  // States για τα δεδομένα και τα σφάλματα
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  // Ενημέρωση των fields καθώς γράφει ο χρήστης
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        // ΑΠΟΘΗΚΕΥΣΗ ΤΟΥ TOKEN
        localStorage.setItem('auth_token', data.token);
        //document.cookie = `auth_token=${data.token}; path=/; domain=.e-beehive.local; max-age=86400; samesite=lax`;
        navigate('/');
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Πρόβλημα σύνδεσης με τον διακομιστή");
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: '#fafafa' }}>
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 3, borderTop: '8px solid #fbc02d' }}>

          <Typography component="h1" variant="h5" sx={{ fontWeight: 'bold', mb: 3 }}>Είσοδος</Typography>

          {/* Εμφάνιση μηνύματος λάθους αν υπάρχει */}
          {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              autoFocus
              color="warning"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Κωδικός"
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={handleChange}
              color="warning"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, py: 1.5, backgroundColor: '#fbc02d', color: '#000', fontWeight: 'bold' }}
            >
              ΣΥΝΔΕΣΗ
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
